import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import "../../styles/customers/createCustomer.scss";
import "../../styles/assets/assets.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import QRCode from "qrcode";
import Layout from "../../Layout/layout";
import IconSelector from "../commoncomponents/IconSelector";
import visionTrakLogo from "../../Assets/visiontrak-logo-colored.png";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { utcToLocal, utcToDDMMYYYY } from "../../utils/dateConvert";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import RoleAccessBadge from "../common/roleAccessBadge";
import "../../styles/common/groupAllocation.scss";

const LICENCE_CLASSES = [
  { code: "C", vehicle: "Car", description: "Cars, vans and utes up to 4.5t GVM.", trailer: "Trailer up to 9t GVM (if stated on licence).", includes: "No" },
  { code: "LR", vehicle: "Light Rigid", description: "Light trucks and buses up to 8t GVM.", trailer: "Trailers up to 9t GVM.", includes: "C" },
  { code: "MR", vehicle: "Medium Rigid", description: "Rigid trucks with 2 axles, with no GVM limit.", trailer: "Trailers up to 9t GVM.", includes: "LR, C" },
  { code: "HR", vehicle: "Heavy Rigid", description: "Rigid vehicles over 8t GVM with 3 or more axles.", trailer: "Trailers up to 9t GVM.", includes: "MR, LR, C" },
  { code: "HC", vehicle: "Heavy Combination", description: "Prime mover and semi-trailer, or rigid vehicle and trailer over 9t.", trailer: "Semi-trailers and large trailers.", includes: "HR, MR, LR, C" },
  { code: "MC", vehicle: "Multi Combination", description: "B-doubles, road trains and multi-trailer combinations.", trailer: "Multiple trailer combinations.", includes: "All lower heavy vehicle classes" },
  { code: "RE", vehicle: "Motorcycle Restricted", description: "LAMS-approved motorcycles.", trailer: "No trailer.", includes: "Separate motorcycle stream" },
  { code: "R", vehicle: "Motorcycle Unrestricted", description: "All motorcycles without restriction.", trailer: "No trailer.", includes: "RE" },
];

class EditAsset extends Component {

  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      customerId: "",
      customerName: "",
      customerString: "",
      name: "",
      friendlyName: "",
      tag1: "",
      tag2: "",
      description: "",
      profiles: [],
      profilesId: "",
      profileName: "",
      profileString: "",
      color: "",
      icon: "",
      notes: "",
      adminNotes: "",
      status: [],
      vehicleTypes: [],
      statusId: "",
      statusName: "",
      statusString: "",
      licenceClass: "",
      vehicleTypeId: "",
      qrToken: "",
      id: "",
      error: false,
      depots: [],
      depotName: "",
      depotId: "",
      dbCreated: "",
      dbUpdated: "",
      micTick: "",
      sosTick: "",
      tempaTick: "",
      tempbTick: "",
      harshTick: "",
      driverTick: "",
      dashTick: "",
      doorSensorTick: "",
      customerError: false,
      nameError: false,
      tag1Error: false,
      tag2Error: false,
      descriptionError: false,
      profileError: false,
      featureError: false,
      colorError: false,
      iconError: false,
      noteError: false,
      adminNoteError: false,
      statusError: false,
      installedDate: "",
      installedDateTick: false,
      uninstalledDate: "",
      uninstalledDateTick: false,
      qrModalOpen: false,
      licenceClassesModalOpen: false,
      qrAsset: null,
      qrDataUrl: "",
      qrUrl: "",
      uatEntryUrl: "",
      groupAllocationGroups: [],
      groupAllocationSelectedIds: [],
      groupAllocationSavedIds: [],
      groupAllocationLoading: false,
      groupAllocationSaving: false,
      groupAllocationMessage: "",
      groupAllocationError: "",
    };
    this.apiInstalled = "";
    this.apiUninstalled = "";
  }
  async componentDidMount() {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.post(
        `${apiHost}/api/Assets/SelectAsset/${this.props.match.params.id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setData(response.data);
        if (this.canManageAssetGroups()) {
          this.getAssetGroupAllocation(response.data.id || this.props.match.params.id);
        }
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }


    if (localStorage.getItem('role') === "SystemAdmin") {
      this.getCustomers();
    }
    if (this.canManageDepot()) {
      this.getDepots();
    }
    this.getProfiles();
    this.getStatus();
    this.getVehicleTypes();
  }

  setData = (data) => {
    const {
      name,
      friendlyName,
      tag1,
      tag2,
      notes,
      profile,
      profilesId,
      status,
      statusId,
      icon,
      description,
      customerName,
      customerId,
      colour,
      adminNotes,
      id,
      depot,
      depotId,
      dbCreated,
      dbUpdated,
      speakerandMic,
      sosDuress,
      tempA,
      tempB,
      harshEvents,
      driverID,
      dashCamera,
      doorSensor,
      licenceClass,
      vehicleTypeId,
      qrToken,
      installed,
      unInstalled,
    } = data;

    this.setState({
      name,
      friendlyName,
      tag1,
      tag2,
      description,
      color: colour,
      icon,
      notes,
      adminNotes,
      customerName,
      customerString: customerName,
      profileName: profile,
      profileString: profile,
      statusName: status,
      statusString: status,
      profilesId,
      statusId,
      customerId,
      id,
      depotName: depot,
      depotId,
      dbCreated,
      dbUpdated,
      micTick: speakerandMic,
      sosTick: sosDuress,
      tempaTick: tempA,
      tempbTick: tempB,
      harshTick: harshEvents,
      driverTick: driverID,
      dashTick: dashCamera,
      doorSensorTick: doorSensor,
      licenceClass: licenceClass || "",
      vehicleTypeId: vehicleTypeId || "",
      qrToken: qrToken || "",
      installedDate: new Date(installed),
      uninstalledDate: new Date(unInstalled),
    });

    this.apiInstalled = installed;
    this.apiUninstalled = unInstalled;
  };

  getCustomers = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllCustomers`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ customers: response.data });
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getDepots = async () => {
    try {
      const response = await axios.get(
        `${apiHost}/api/Depots/GetAllDepots?assetId=${this.props.match.params.id}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        console.log("the depots", response.data);
        this.setState({ depots: response.data });
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getProfiles = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(`${apiHost}/api/Assets/GetAllProfile`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        this.setState({ profiles: response.data });
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getStatus = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(`${apiHost}/api/Assets/GetAllStatus`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        this.setState({ status: response.data });
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getVehicleTypes = async () => {
    try {
      const response = await axios.get(`${apiHost}/api/Assets/GetVehicleTypes`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        this.setState({ vehicleTypes: response.data || [] });
      }
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
    }
  };

  handleCancel = () => {
    this.props.history.push("/customers");
  };

  canManageAssetGroups = () => {
    const role = String(localStorage.getItem("role") || "").replace(/\s+/g, "").toLowerCase();
    return ["systemadmin", "vtdemo", "communitymanager"].includes(role);
  };

  getAssetGroupAllocation = async (assetId = this.state.id) => {
    if (!assetId) {
      return;
    }

    this.setState({
      groupAllocationLoading: true,
      groupAllocationError: "",
      groupAllocationMessage: "",
    });

    try {
      const response = await axios.get(`${apiHost}/api/Group/AssetGroupAllocation/${assetId}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      const groups = response.data.groups || response.data.Groups || [];
      const selectedIds = response.data.groupIds || response.data.GroupIds || groups.filter((group) => group.isMember || group.IsMember).map((group) => group.id || group.Id);

      const selectedIdStrings = selectedIds.map((id) => id.toString());
      this.setState({
        groupAllocationGroups: groups,
        groupAllocationSelectedIds: selectedIdStrings,
        groupAllocationSavedIds: selectedIdStrings,
        groupAllocationLoading: false,
      });
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.setState({
          groupAllocationError: "Unable to load group allocation.",
          groupAllocationLoading: false,
        });
      }
    }
  };

  toggleGroupAllocation = (groupId) => {
    const groupIdText = groupId.toString();
    this.setState((state) => ({
      groupAllocationMessage: "",
      groupAllocationError: "",
      groupAllocationSelectedIds: state.groupAllocationSelectedIds.includes(groupIdText)
        ? state.groupAllocationSelectedIds.filter((id) => id !== groupIdText)
        : [...state.groupAllocationSelectedIds, groupIdText],
    }));
  };

  handleSelectAllGroups = () => {
    this.setState((state) => ({
      groupAllocationMessage: "",
      groupAllocationError: "",
      groupAllocationSelectedIds: state.groupAllocationGroups.map((group) => (group.id || group.Id).toString()),
    }));
  };

  handleClearGroups = () => {
    this.setState({
      groupAllocationMessage: "",
      groupAllocationError: "",
      groupAllocationSelectedIds: [],
    });
  };

  handleSaveGroupAllocation = async () => {
    this.setState({
      groupAllocationSaving: true,
      groupAllocationError: "",
      groupAllocationMessage: "",
    });

    try {
      const response = await axios.post(
        `${apiHost}/api/Group/UpdateAssetGroupAllocation`,
        {
          assetId: this.state.id,
          groupIds: this.state.groupAllocationSelectedIds,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      const groups = response.data.groups || response.data.Groups || [];
      const selectedIds = response.data.groupIds || response.data.GroupIds || [];

      const selectedIdStrings = selectedIds.map((id) => id.toString());
      this.setState({
        groupAllocationGroups: groups,
        groupAllocationSelectedIds: selectedIdStrings,
        groupAllocationSavedIds: selectedIdStrings,
        groupAllocationSaving: false,
        groupAllocationMessage: "Group allocation saved.",
      });
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.setState({
          groupAllocationSaving: false,
          groupAllocationError: "Unable to save group allocation.",
        });
      }
    }
  };

  handleName = (evt) => {
    if (evt.target.value == "") {
      this.setState({ nameError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.setState({ name: evt.target.value });
  };

  handlefriendlyName = (evt) => {
    this.setState({ friendlyName: evt.target.value });
  };

  handleTag1 = (evt) => {
    this.setState({ tag1: evt.target.value });
  };

  handleTag2 = (evt) => {
    this.setState({ tag2: evt.target.value });
  };

  handleCustomer = (evt) => {
    this.state.customers.forEach((customer) => {
      if (customer.name == evt.target.value) {
        this.setState({
          customerId: customer.id,
          customerString: customer.name,
        });
      }
    });
  };

  handleDepot = (evt) => {
    if (evt.target.value == "default") {
      this.setState({ depotId: null, depotName: 'Select Depot' });
    }
    this.state.depots.forEach((depot) => {
      if (depot.name == evt.target.value) {
        this.setState({ depotId: depot.id, depotName: depot.name });
      }
    });
  };

  canManageDepot = () => {
    const role = (localStorage.getItem("role") || "").replace(/\s+/g, "").toLowerCase();
    return role === "systemadmin" || role === "vtdemo" || role === "communitymanager";
  };

  handleDescription = (evt) => {
    this.setState({ description: evt.target.value });
  };

  handleProfile = (evt) => {
    this.state.profiles.forEach((profile) => {
      if (profile.profileName == evt.target.value) {
        this.setState({
          profilesId: profile.id,
          profileString: profile.profileName,
          profileName: profile.profileName,
        });
      }
    });
  };

  handleColor = (evt) => {
    this.setState({ color: evt.target.value });
  };

  handleColourDefault = () => {
    this.setState({ color: "#160f9e" });
  };

  getColorPickerValue = () => {
    const color = String(this.state.color || "").trim();
    return /^#[0-9a-fA-F]{6}$/.test(color) ? color : "#160f9e";
  };

  handleIcon = (evt) => {
    this.setState({ icon: evt.target.value });
  };

  handleIconSelection = (icon) => {
    this.setState({ icon });
  };

  handleIconDefault = () => {
    this.setState({
      icon: "fa fa-truck",
    });
  };

  handleNotes = (evt) => {
    this.setState({ notes: evt.target.value });
  };

  handleAdminNotes = (evt) => {
    this.setState({ adminNotes: evt.target.value });
  };

  handleStatus = (evt) => {
    if (evt.target.value == "") {
      this.setState({ statusError: true });
    } else {
      this.setState({ statusError: false });
    }
    this.state.status.forEach((stats) => {
      if (stats.name == evt.target.value) {
        this.setState({
          statusId: stats.id,
          statusString: stats.name,
          statusName: stats.name,
        });
      }
    });
  };

  handleLicenceClass = (evt) => {
    this.setState({ licenceClass: evt.target.value });
  };

  handleVehicleType = (evt) => {
    this.setState({ vehicleTypeId: evt.target.value ? parseInt(evt.target.value, 10) : "" });
  };

  getQrReadiness = () => {
    const missing = [];
    if (!this.state.qrToken) missing.push("QR token");
    if (!this.state.vehicleTypeId) missing.push("vehicle type");
    if (!this.state.licenceClass) missing.push("licence class");

    return missing;
  };

  loadImage = (src) => new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });

  getQrLabelDataUrl = async (asset, qrUrl) => {
    const qrDataUrl = await QRCode.toDataURL(qrUrl, {
      errorCorrectionLevel: "M",
      margin: 1,
      width: 520,
      color: {
        dark: "#000000",
        light: "#ffffff",
      },
    });

    const qrImage = await this.loadImage(qrDataUrl);
    const logoImage = await this.loadImage(visionTrakLogo);
    const canvas = document.createElement("canvas");
    canvas.width = 1100;
    canvas.height = 1450;
    const ctx = canvas.getContext("2d");

    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.textAlign = "center";
    const logoWidth = 440;
    const logoHeight = (logoImage.height / logoImage.width) * logoWidth;
    ctx.drawImage(logoImage, (canvas.width - logoWidth) / 2, 80, logoWidth, logoHeight);

    ctx.fillStyle = "#1c2430";
    ctx.font = "700 66px Arial, sans-serif";
    ctx.fillText(asset.name || "Asset QR Code", canvas.width / 2, 275);

    if (asset.friendlyName) {
      ctx.fillStyle = "#697386";
      ctx.font = "400 38px Arial, sans-serif";
      ctx.fillText(asset.friendlyName, canvas.width / 2, 335);
    }

    ctx.fillStyle = "#4b5565";
    ctx.font = "400 30px Arial, sans-serif";
    ctx.fillText(`Asset ID: ${asset.id}`, canvas.width / 2, asset.friendlyName ? 400 : 345);

    const qrSize = 700;
    ctx.drawImage(qrImage, (canvas.width - qrSize) / 2, 485, qrSize, qrSize);

    ctx.fillStyle = "#4b5565";
    ctx.font = "400 32px Arial, sans-serif";
    ctx.fillText("Scan for driver pre-start and post-trip workflow", canvas.width / 2, 1265);

    ctx.strokeStyle = "#d5dce8";
    ctx.lineWidth = 3;
    ctx.strokeRect(28, 28, canvas.width - 56, canvas.height - 56);

    return canvas.toDataURL("image/png");
  };

  handleOpenQr = async () => {
    if (!this.state.id) {
      return;
    }

    this.props.setLoadingPageAction(true);
    try {
      const response = await axios.post(
        `${apiHost}/api/Assets/${this.state.id}/QrToken`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      const data = response.data || {};
      const qrToken = data.qrToken || this.state.qrToken;
      const qrAsset = {
        id: this.state.id,
        name: this.state.name,
        friendlyName: this.state.friendlyName,
        qrToken,
      };
      const qrUrl = data.url || `https://vttoolsuser-assettrak.visiontrak.com.au/Checks/index.php?t=${encodeURIComponent(qrToken)}`;
      const qrDataUrl = await this.getQrLabelDataUrl(qrAsset, qrUrl);

      this.setState({
        qrToken,
        qrModalOpen: true,
        qrAsset,
        qrDataUrl,
        qrUrl,
        uatEntryUrl: data.uatEntryUrl || "",
      });
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
    } finally {
      this.props.setLoadingPageAction(false);
    }
  };

  handleCloseQrModal = () => {
    this.setState({
      qrModalOpen: false,
      qrAsset: null,
      qrDataUrl: "",
      qrUrl: "",
      uatEntryUrl: "",
    });
  };

  handleOpenLicenceClasses = () => this.setState({ licenceClassesModalOpen: true });

  handleCloseLicenceClasses = () => this.setState({ licenceClassesModalOpen: false });

  handleDownloadQr = () => {
    const { qrAsset, qrDataUrl } = this.state;
    if (!qrDataUrl || !qrAsset) {
      return;
    }

    const link = document.createElement("a");
    const fileName = String(qrAsset.name || "asset")
      .replace(/[^a-z0-9-_]+/gi, "-")
      .replace(/^-+|-+$/g, "") || "asset";
    link.href = qrDataUrl;
    link.download = `${fileName}-QR.png`;
    link.click();
  };

  dataUrlToBlob = (dataUrl) => {
    const parts = dataUrl.split(",");
    const mimeMatch = parts[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const binary = atob(parts[1]);
    const length = binary.length;
    const bytes = new Uint8Array(length);

    for (let index = 0; index < length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }

    return new Blob([bytes], { type: mime });
  };

  handlePrintQr = () => {
    const { qrAsset, qrDataUrl } = this.state;
    if (!qrDataUrl) {
      return;
    }

    const imageUrl = URL.createObjectURL(this.dataUrlToBlob(qrDataUrl));
    const iframe = document.createElement("iframe");
    iframe.title = "Asset QR Code Print";
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "1px";
    iframe.style.height = "1px";
    iframe.style.border = "0";
    iframe.style.opacity = "0";

    const escapedTitle = `${qrAsset && qrAsset.name ? qrAsset.name : "Asset"} - QR Code`
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");

    const cleanup = () => {
      setTimeout(() => {
        URL.revokeObjectURL(imageUrl);
        if (iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
      }, 1000);
    };

    document.body.appendChild(iframe);
    const printDocument = iframe.contentWindow.document;
    printDocument.open();
    printDocument.write(`
      <html>
        <head>
          <title>${escapedTitle}</title>
          <style>
            html, body { background: #fff; margin: 0; min-height: 100%; }
            body { display: flex; align-items: center; justify-content: center; padding: 4mm; }
            img { display: block; max-width: 200mm; width: 100%; height: auto; }
            @page { margin: 4mm; }
            @media print { body { display: block; padding: 0; text-align: center; } img { margin: 0 auto; max-width: 200mm; width: 100%; } }
          </style>
        </head>
        <body>
          <img id="qrLabel" src="${imageUrl}" alt="Asset QR Code" />
        </body>
      </html>
    `);
    printDocument.close();

    const printImage = printDocument.getElementById("qrLabel");
    const triggerPrint = () => {
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        cleanup();
      }, 250);
    };

    if (printImage.complete) {
      triggerPrint();
    } else {
      printImage.onload = triggerPrint;
      printImage.onerror = cleanup;
    }
  };

  handleTestQr = () => {
    const href = this.state.uatEntryUrl || this.state.qrUrl;
    if (!href) return;

    const parentWindow = window.opener && !window.opener.closed ? window.opener : window;
    const testTab = parentWindow.open(href, "_blank");
    if (testTab) {
      testTab.focus();
      return;
    }

    window.open(href, "_blank");
  };

  handleCreate = async () => {
    this.validationCheck();
    console.log("createe", this.state)
    let {
      name,
      friendlyName,
      description,
      tag1,
      tag2,
      customerId,
      color,
      icon,
      notes,
      adminNotes,
      profilesId,
      statusId,
      depotId,
      profileName,
      statusName,
      installedDate,
      uninstalledDate,
      licenceClass,
      vehicleTypeId,
    } = this.state;

    if (this.state.installedDate.toString().includes("Mon Jan 01 0001 00:00:00")) {
      installedDate = "0001-01-01T00:00:00";
    } else {
      installedDate.setMinutes(installedDate.getMinutes() - installedDate.getTimezoneOffset());
    }

    if (this.state.uninstalledDate.toString().includes("Mon Jan 01 0001 00:00:00")) {
      uninstalledDate = "0001-01-01T00:00:00";
    } else {
      uninstalledDate.setMinutes(uninstalledDate.getMinutes() - uninstalledDate.getTimezoneOffset());
    }

    if (name && customerId && profilesId && statusId) {
      this.props.setLoadingPageAction(true);
      try {
        const response = await axios.post(
          `${apiHost}/api/Assets/Update`,
          {
            Name: name,
            friendlyName: friendlyName,
            Description: description,
            CustomerId: customerId,
            Tag1: tag1,
            Tag2: tag2,
            ProfilesName: profileName,
            Features: 20,
            Colour: color,
            Icon: icon,
            Notes: notes,
            AdminNotes: adminNotes,
            StatusName: statusName,
            ExternalId: 111,
            id: this.state.id,
            DepotId: depotId,
            SpeakerandMic: this.state.micTick,
            SOSDuress: this.state.sosTick,
            TempA: this.state.tempaTick,
            TempB: this.state.tempbTick,
            HarshEvents: this.state.harshTick,
            DriverID: this.state.driverTick,
            DashCamera: this.state.dashTick,
            DoorSensor: this.state.doorSensorTick,
            LicenceClass: licenceClass,
            VehicleTypeId: vehicleTypeId || null,
            Installed: installedDate,
            UnInstalled: uninstalledDate,
            // Installed: installedDate
            //   .toString()
            //   .includes("Mon Jan 01 0001 00:00:00")
            //   ? installedDate
            //   : installedDate,
            // UnInstalled: uninstalledDate
            //   .toString()
            //   .includes("Mon Jan 01 0001 00:00:00")
            //   ? uninstalledDate
            //   : uninstalledDate,
            //DbCreated:new Date(dbCreated),
            //DbUpdated:new Date(dbUpdated)
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        if (response.status == "200") {
          //  this.props.history.push("/assets");
          this.props.history.goBack();
          this.props.setLoadingPageAction(false);
        }
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
        this.setState({ error_authorisation: true });
      }
    } else {
      this.setState({ error: true });
      setTimeout(() => {
        this.setState({ error: false });
      }, 3000);
    }
  };

  validationCheck = () => {
    if (!this.state.name) {
      this.setState({ nameError: true });
    }
    // if(!this.state.description){
    //   this.setState({descriptionError:true})
    // }
    // if(!this.state.tag1){
    //   this.setState({tag1Error:true})
    // }
    // if(!this.state.tag2){
    //   this.setState({tag2Error:true})
    // }
    if (!this.state.customerId) {
      this.setState({ customerError: true });
    }
    // if(!this.state.color){
    //   this.setState({colorError:true})
    // }
    // if(!this.state.icon){
    //   this.setState({iconError:true})
    // }
    // if(!this.state.notes){
    //   this.setState({noteError:true})
    // }
    // if(!this.state.adminNotes){
    //   this.setState({adminNoteError:true})
    // }
    if (!this.state.profilesId) {
      this.setState({ profileError: true });
    }
    if (!this.state.statusId) {
      this.setState({ statusError: true });
    }
  };

  handleBack = () => {
    // this.props.history.push("/assets");
    this.props.history.goBack();
  };

  handleMic = (e) => {
    this.setState({ micTick: !this.state.micTick });
  };

  handleSos = (e) => {
    this.setState({ sosTick: !this.state.sosTick });
  };

  handleTempA = (e) => {
    this.setState({ tempaTick: !this.state.tempaTick });
  };

  handleTempB = (e) => {
    this.setState({ tempbTick: !this.state.tempbTick });
  };

  handleHarsh = (e) => {
    this.setState({ harshTick: !this.state.harshTick });
  };

  handleDriver = (e) => {
    this.setState({ driverTick: !this.state.driverTick });
  };

  handleDash = (e) => {
    this.setState({ dashTick: !this.state.dashTick });
  };

  handleDoorSensor = (e) => {
    this.setState({ doorSensorTick: !this.state.doorSensorTick });
  };

  handleInstalledCalender = (date) => {
    console.log("dateis...", utcToDDMMYYYY(date));
    this.setState({ installedDate: date });
    this.setState({ installedDateTick: false });
  };

  handleOPenInstalledCalander = () => {
    this.setState({ installedDateTick: !this.state.installedDateTick });
  };

  handleUnInstalledCalender = (date) => {
    console.log("uninstalled date selectedd", date);
    this.setState({ uninstalledDate: date });
    this.setState({ uninstalledDateTick: false });
  };

  handleOPenUnInstalledCalander = () => {
    this.setState({ uninstalledDateTick: !this.state.uninstalledDateTick });
  };

  handleTrashInstalled = () => {
    if (this.state.installedDateTick <= 0) {
      this.setState({ installedDate: "Mon Jan 01 0001 00:00:00" });
    }
  };

  handleTodayInstalled = () => {
    if (this.state.installedDateTick <= 0) {
      this.setState({ installedDate: new Date() });
    }
  };

  handleTrashUninstalled = () => {
    if (this.state.uninstalledDateTick <= 0) {
      this.setState({ uninstalledDate: "Mon Jan 01 0001 00:00:00" });
    }
  };
  handleTodayUninstalled = () => {
    if (this.state.uninstalledDateTick <= 0) {
      this.setState({ uninstalledDate: new Date() });
    }
  };

  render() {
    const {
      name,
      friendlyName,
      description,
      tag1,
      tag2,
      color,
      icon,
      notes,
      adminNotes,
      profiles,
      status,
      vehicleTypes,
      customerName,
      profileString,
      statusString,
      depots,
      depotName,
      dbCreated,
      dbUpdated,
      customerError,
      nameError,
      profileError,
      statusError,
      installedDate,
      uninstalledDate,
      licenceClass,
      vehicleTypeId,
      qrAsset,
      qrDataUrl,
      qrModalOpen,
      licenceClassesModalOpen,
      groupAllocationGroups,
      groupAllocationSelectedIds,
      groupAllocationSavedIds,
      groupAllocationLoading,
      groupAllocationSaving,
      groupAllocationMessage,
      groupAllocationError,
    } = this.state;
    const hasPendingGroupAllocationChanges =
      [...groupAllocationSelectedIds].sort().join(",") !==
      [...groupAllocationSavedIds].sort().join(",");

    const canManageDepot = this.canManageDepot();
    const selectDepot = (
      <Form.Control as="select" onChange={this.handleDepot} value={depotName || "default"} disabled={!canManageDepot}>
        <option value="default">Select Depot</option>
        {canManageDepot
          ? depots.map((depot) => (
            <option key={depot.id} value={depot.name}>{depot.name}</option>
          ))
          : depotName && <option value={depotName}>{depotName}</option>}
      </Form.Control>
    );
    console.log("instedsdf date is....", installedDate);
    const role = localStorage.getItem('role');
    const isSystemAdmin = role === "SystemAdmin";
    const isCommunityManager = ["CommunityManager", "Community Manager"].includes(role);
    const canViewConfiguration = isSystemAdmin || isCommunityManager;
    const canEditAssetColour = isSystemAdmin || isCommunityManager;
    const canManageAssetGroups = this.canManageAssetGroups();
    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Edit Asset </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper asset-edit-page">
              <div className="asset-edit-header">
                <div>
                  <span className="asset-edit-kicker">Asset editor</span>
                  <h2>{name || "Edit Asset"}</h2>
                  <div className="asset-edit-subtitle">
                    {customerName && <span>{customerName}</span>}
                    {profileString && <span>{profileString}</span>}
                    {statusString && (
                      <span className={`asset-status-badge asset-status-badge-${(statusString || "").toLowerCase().replace(/\s+/g, "-")}`}>
                        {statusString === "Disable" ? "Disabled" : statusString}
                      </span>
                    )}
                  </div>
                </div>
                <div className="asset-edit-actions">
                  <Button variant="outline-secondary" onClick={this.handleBack}>
                    Back to List
                  </Button>
                  <Button variant="primary" onClick={this.handleCreate}>
                    Save Changes
                  </Button>
                </div>
              </div>

              <Form className="asset-edit-form-modern">
                <section className="asset-edit-section">
                  <div className="asset-edit-section-title">
                    <h3>Asset Identity</h3>
                    <p>Customer ownership, naming and descriptive details.</p>
                  </div>
                  <div className="asset-edit-grid">
                    <Form.Group controlId="assetCustomer">
                      <div className="asset-field-label-row">
                        <Form.Label>Customer</Form.Label>
                      </div>
                      <Form.Control type="text" value={customerName || ""} disabled />
                      <p style={customerError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Customer field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="assetDepot">
                      <div className="asset-field-label-row">
                        <Form.Label>Depot</Form.Label>
                        <RoleAccessBadge role="CommunityManager" />
                      </div>
                      {selectDepot}
                    </Form.Group>

                    <Form.Group controlId="assetName">
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        value={name}
                        onChange={this.handleName}
                        type="text"
                        disabled={!isSystemAdmin}
                      />
                      <p style={nameError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Name field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="assetFriendlyName">
                      <Form.Label>Friendly Name</Form.Label>
                      <Form.Control
                        value={friendlyName}
                        onChange={this.handlefriendlyName}
                        type="text"
                      />
                    </Form.Group>

                    {isSystemAdmin && (
                      <React.Fragment>
                        <Form.Group controlId="assetTag1">
                          <Form.Label>Tag1</Form.Label>
                          <Form.Control
                            value={tag1}
                            onChange={this.handleTag1}
                            type="text"
                          />
                        </Form.Group>

                        <Form.Group controlId="assetTag2">
                          <Form.Label>Tag2</Form.Label>
                          <Form.Control
                            value={tag2}
                            onChange={this.handleTag2}
                            type="text"
                          />
                        </Form.Group>

                        <Form.Group className="asset-edit-wide" controlId="assetDescription">
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            value={description}
                            as="textarea"
                            rows="3"
                            onChange={this.handleDescription}
                          />
                        </Form.Group>
                      </React.Fragment>
                    )}
                  </div>
                </section>

                {canViewConfiguration && (
                  <section className="asset-edit-section">
                    <div className="asset-edit-section-title asset-edit-section-title-with-actions">
                      <div>
                        <h3>Configuration</h3>
                        <p>Profile, status, colour and icon used across the platform.</p>
                      </div>
                      {isCommunityManager && (
                        <span className="asset-community-manager-badge">
                          Community Manager
                        </span>
                      )}
                    </div>
                    <div className="asset-edit-grid">
                      <Form.Group controlId="assetProfile">
                        <Form.Label>Profile</Form.Label>
                        <Form.Control
                          as="select"
                          onChange={this.handleProfile}
                          value={profileString}
                          disabled={!isSystemAdmin}
                        >
                          <option value="default">Select Profile</option>
                          {profiles.map((profile, index) => (
                            <option key={index} value={profile.profileName}>{profile.profileName}</option>
                          ))}
                        </Form.Control>
                        <p style={profileError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                          The Profile field is required.
                        </p>
                      </Form.Group>

                      <Form.Group controlId="assetStatus">
                        <Form.Label>Status</Form.Label>
                        <Form.Control
                          as="select"
                          onChange={(e) => this.handleStatus(e)}
                          value={statusString}
                          disabled={!isSystemAdmin}
                        >
                          {status.map((stats, index) => (
                            <option key={index}>{stats.name}</option>
                          ))}
                        </Form.Control>
                        <p style={statusError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                          The Status field is required.
                        </p>
                      </Form.Group>

                      <Form.Group controlId="assetColour">
                        <Form.Label>Colour</Form.Label>
                        <div className="colour-picker-field">
                          <Form.Control
                            value={this.getColorPickerValue()}
                            onChange={this.handleColor}
                            type="color"
                            title="Choose colour"
                            disabled={!canEditAssetColour}
                          />
                          <Form.Control
                            value={color}
                            onChange={this.handleColor}
                            type="text"
                            disabled={!canEditAssetColour}
                          />
                          <button
                            type="button"
                            className="colour-default-button"
                            onClick={this.handleColourDefault}
                            disabled={!canEditAssetColour}
                          >
                            Colour Reset
                          </button>
                        </div>
                      </Form.Group>

                      {isSystemAdmin && (
                        <Form.Group className="asset-edit-wide" controlId="assetIcon">
                          <Form.Label>Icon</Form.Label>
                          <IconSelector
                            value={icon}
                            onChange={this.handleIconSelection}
                          />
                          <div className="asset-edit-icon-row">
                            <Form.Control
                              value={icon}
                              onChange={this.handleIcon}
                              type="text"
                            />
                            <button
                              type="button"
                              className="visual-default-button"
                              onClick={this.handleIconDefault}
                            >
                              Icon Reset
                            </button>
                          </div>
                        </Form.Group>
                      )}
                    </div>
                  </section>
                )}

                {canManageAssetGroups && (
                  <section className="asset-edit-section">
                    <div className="asset-edit-section-title asset-edit-section-title-with-actions">
                      <div>
                        <h3>Group Allocation</h3>
                        <p>Add or remove this asset from groups available to your account.</p>
                      </div>
                      <RoleAccessBadge role="CommunityManager" />
                      <div className="asset-group-allocation-actions">
                        <Button
                          variant="outline-secondary"
                          type="button"
                          onClick={this.handleSelectAllGroups}
                          disabled={groupAllocationLoading || groupAllocationSaving || groupAllocationGroups.length === 0}
                        >
                          All
                        </Button>
                        <Button
                          variant="outline-secondary"
                          type="button"
                          onClick={this.handleClearGroups}
                          disabled={groupAllocationLoading || groupAllocationSaving}
                        >
                          None
                        </Button>
                        <Button
                          className={hasPendingGroupAllocationChanges ? "group-allocation-save-pending" : ""}
                          variant="primary"
                          type="button"
                          onClick={this.handleSaveGroupAllocation}
                          disabled={groupAllocationLoading || groupAllocationSaving}
                        >
                          {groupAllocationSaving ? "Saving..." : "Save Groups"}
                        </Button>
                      </div>
                    </div>
                    <div className="asset-group-allocation-notice">
                      This is an organisational visibility setting. Changes here affect which users in the organisation can see this asset through their group access.
                    </div>
                    <div className="asset-group-allocation-summary">
                      <strong>{groupAllocationSelectedIds.length}</strong> of <strong>{groupAllocationGroups.length}</strong> available groups selected
                    </div>
                    {groupAllocationLoading ? (
                      <div className="asset-group-allocation-empty">Loading groups...</div>
                    ) : groupAllocationGroups.length === 0 ? (
                      <div className="asset-group-allocation-empty">No groups available to your account for this asset.</div>
                    ) : (
                      <div className="asset-group-allocation-grid">
                        {groupAllocationGroups.map((group) => {
                          const groupId = (group.id || group.Id || "").toString();
                          const groupName = group.name || group.Name || "Group";
                          const groupStatus = group.status || group.Status || "";
                          const isSelected = groupAllocationSelectedIds.includes(groupId);

                          return (
                            <label className={`asset-group-allocation-item ${isSelected ? "selected" : ""}`} key={groupId}>
                              <input
                                checked={isSelected}
                                onChange={() => this.toggleGroupAllocation(groupId)}
                                type="checkbox"
                              />
                              <span>
                                <strong>{groupName}</strong>
                                {groupStatus && <small>{groupStatus}</small>}
                              </span>
                            </label>
                          );
                        })}
                      </div>
                    )}
                    {groupAllocationMessage && <p className="asset-group-allocation-message">{groupAllocationMessage}</p>}
                    {groupAllocationError && <p className="asset-group-allocation-error">{groupAllocationError}</p>}
                  </section>
                )}

                <section className="asset-edit-section">
                  <div className="asset-edit-section-title">
                    <h3>Features</h3>
                    <p>Available hardware and alert capabilities for this asset.</p>
                  </div>
                  <div className="asset-feature-toggle-grid">
                    <Form.Check checked={this.state.micTick} onChange={(e) => this.handleMic(e)} label="Speaker & Mic" type="checkbox" disabled={!isSystemAdmin} />
                    <Form.Check checked={this.state.sosTick} onChange={(e) => this.handleSos(e)} label="SOS (Duress)" type="checkbox" disabled={!isSystemAdmin} />
                    <Form.Check checked={this.state.tempaTick} onChange={(e) => this.handleTempA(e)} label="Temp A" type="checkbox" disabled={!isSystemAdmin} />
                    <Form.Check checked={this.state.tempbTick} onChange={(e) => this.handleTempB(e)} label="Temp B" type="checkbox" disabled={!isSystemAdmin} />
                    <Form.Check checked={this.state.harshTick} onChange={(e) => this.handleHarsh(e)} label="Harsh Events" type="checkbox" disabled={!isSystemAdmin} />
                    <Form.Check checked={this.state.driverTick} onChange={(e) => this.handleDriver(e)} label="Driver ID (Fob Key)" type="checkbox" disabled={!isSystemAdmin} />
                    <Form.Check checked={this.state.dashTick} onChange={(e) => this.handleDash(e)} label="Dash Camera" type="checkbox" disabled={!isSystemAdmin} />
                    <Form.Check checked={this.state.doorSensorTick} onChange={(e) => this.handleDoorSensor(e)} label="Door Sensor" type="checkbox" disabled={!isSystemAdmin} />
                  </div>
                </section>

                <section className="asset-edit-section">
                  <div className="asset-edit-section-title asset-edit-section-title-with-actions">
                    <div>
                      <h3>QR Driver Authentication</h3>
                      <p>Vehicle type and licence requirement used by the QR driver PIN workflow.</p>
                    </div>
                    <div className="asset-qr-cell asset-edit-qr-actions">
                      <button
                        className="asset-licence-reference-open"
                        onClick={this.handleOpenLicenceClasses}
                        type="button"
                      >
                        <i className="fa fa-info-circle"></i>
                        Licence classes
                      </button>
                      <span className={`asset-qr-badge ${this.getQrReadiness().length ? "needs-setup" : "ready"}`}>
                        <i className={this.getQrReadiness().length ? "fa fa-exclamation-circle" : "fa fa-check-circle"}></i>
                        {this.getQrReadiness().length ? "Setup" : "Ready"}
                      </span>
                      <button
                        className="asset-qr-open"
                        onClick={this.handleOpenQr}
                        title={this.state.qrToken ? "View printable QR code" : "Generate QR token and view printable QR code"}
                        type="button"
                      >
                        <i className="fa fa-qrcode"></i>
                      </button>
                    </div>
                  </div>
                  <div className="asset-edit-grid">
                    <Form.Group controlId="assetVehicleType">
                      <Form.Label>Vehicle Type</Form.Label>
                      <Form.Control
                        as="select"
                        onChange={this.handleVehicleType}
                        value={vehicleTypeId || ""}
                      >
                        <option value="">Select vehicle type</option>
                        {vehicleTypes.map((type) => (
                          <option key={type.id} value={type.id}>{type.name}</option>
                        ))}
                      </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="assetLicenceClass">
                      <Form.Label>Required Licence Class</Form.Label>
                      <Form.Control
                        as="select"
                        onChange={this.handleLicenceClass}
                        value={licenceClass || ""}
                      >
                        <option value="">No licence requirement</option>
                        {["C", "LR", "MR", "HR", "HC", "MC", "RE", "R"].map((licence) => (
                          <option key={licence} value={licence}>{licence}</option>
                        ))}
                      </Form.Control>
                    </Form.Group>

                    <Form.Group className="asset-edit-wide" controlId="assetQrToken">
                      <Form.Label>QR Token</Form.Label>
                      <Form.Control
                        value={this.state.qrToken || "Generated from the Assets table QR action"}
                        type="text"
                        disabled
                      />
                    </Form.Group>
                  </div>
                </section>

                <section className="asset-edit-section">
                  <div className="asset-edit-section-title">
                    <h3>Lifecycle & Notes</h3>
                    <p>Installation dates and notes for operational context.</p>
                  </div>
                  <div className="asset-edit-grid">
                    <Form.Group controlId="assetInstalled">
                      <Form.Label>Installed</Form.Label>
                      <div className="asset-date-control">
                        <Button onClick={this.handleOPenInstalledCalander} variant="light" disabled={!isSystemAdmin}>
                          {installedDate.toString().includes("Mon Jan 01 0001 00:00:00") ? "Date Asset Was Installed" : utcToDDMMYYYY(installedDate)}
                        </Button>
                        <Button variant="light" className="asset-calender" onClick={this.handleTodayInstalled} title="Go to today" disabled={!isSystemAdmin}>
                          <span><i className="fa fa-asterisk" /></span>
                        </Button>
                        <Button variant="light" className="asset-calender" onClick={this.handleTrashInstalled} title="Clear Selection" disabled={!isSystemAdmin}>
                          <span><i className="fa fa-trash-o" /></span>
                        </Button>
                      </div>
                      {this.state.installedDateTick > 0 && (
                        <div className="calenderDiv">
                          <Calendar
                            onChange={this.handleInstalledCalender}
                            value={this.state.installedDate.toString().includes("Mon Jan 01 0001 00:00:00") ? new Date() : this.state.installedDate}
                          />
                        </div>
                      )}
                    </Form.Group>

                    <Form.Group controlId="assetUninstalled">
                      <Form.Label>Uninstalled</Form.Label>
                      <div className="asset-date-control">
                        <Button onClick={this.handleOPenUnInstalledCalander} variant="light" disabled={!isSystemAdmin}>
                          {uninstalledDate.toString().includes("Mon Jan 01 0001 00:00:00") ? "Date Asset Was Uninstalled" : utcToDDMMYYYY(uninstalledDate)}
                        </Button>
                        <Button variant="light" className="asset-calender" onClick={this.handleTodayUninstalled} title="Go to today" disabled={!isSystemAdmin}>
                          <span><i className="fa fa-asterisk" /></span>
                        </Button>
                        <Button variant="light" className="asset-calender" onClick={this.handleTrashUninstalled} title="Clear Selection" disabled={!isSystemAdmin}>
                          <span><i className="fa fa-trash-o" /></span>
                        </Button>
                      </div>
                      {this.state.uninstalledDateTick > 0 && (
                        <div className="calenderDiv">
                          <Calendar
                            onChange={this.handleUnInstalledCalender}
                            value={this.state.uninstalledDate.toString().includes("Mon Jan 01 0001 00:00:00") ? new Date() : this.state.uninstalledDate}
                          />
                        </div>
                      )}
                    </Form.Group>

                    <Form.Group className="asset-edit-wide" controlId="assetNotes">
                      <Form.Label>Notes</Form.Label>
                      <Form.Control value={notes} as="textarea" rows="3" onChange={this.handleNotes} />
                    </Form.Group>

                    {isSystemAdmin && (
                      <Form.Group className="asset-edit-wide" controlId="assetAdminNotes">
                        <Form.Label>Admin Notes</Form.Label>
                        <Form.Control
                          value={adminNotes}
                          as="textarea"
                          rows="3"
                          onChange={this.handleAdminNotes}
                        />
                      </Form.Group>
                    )}
                  </div>
                </section>

                <div className="asset-edit-meta">
                  <div>
                    <span>Created</span>
                    <strong>{dbCreated ? utcToLocal(dbCreated) : "Not created"}</strong>
                  </div>
                  <div>
                    <span>Updated</span>
                    <strong>{dbUpdated ? utcToLocal(dbUpdated) : "Not updated"}</strong>
                  </div>
                </div>

                {this.state.error && (
                  <p className="error-text asset-edit-error">
                    Please fill all the Required fields
                  </p>
                )}

                <div className="asset-edit-footer">
                  <Button variant="outline-secondary" onClick={this.handleBack}>
                    Back to List
                  </Button>
                  <Button variant="primary" onClick={this.handleCreate}>
                    Save Changes
                  </Button>
                </div>
                {qrModalOpen && (
                  <div className="asset-qr-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="assetQrModalTitle">
                    <div className="asset-qr-modal">
                      <div className="asset-qr-modal-header">
                        <h3 id="assetQrModalTitle">Asset QR Code</h3>
                        <button onClick={this.handleCloseQrModal} type="button" aria-label="Close QR modal">
                          <i className="fa fa-times"></i>
                        </button>
                      </div>
                      <div className="asset-qr-modal-body">
                        {qrDataUrl && (
                          <img
                            alt={`${qrAsset && qrAsset.name ? qrAsset.name : "Asset"} QR code`}
                            className="asset-qr-label-preview"
                            src={qrDataUrl}
                          />
                        )}
                      </div>
                      <div className="asset-qr-modal-actions">
                        <Button variant="primary" onClick={this.handleDownloadQr}>
                          Download PNG
                        </Button>
                        <Button variant="secondary" onClick={this.handlePrintQr}>
                          Print
                        </Button>
                        <Button variant="outline-primary" onClick={this.handleTestQr}>
                          Test
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
                {licenceClassesModalOpen && (
                  <div className="asset-qr-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="licenceClassesModalTitle">
                    <div className="asset-qr-modal asset-licence-reference-modal">
                      <div className="asset-qr-modal-header">
                        <div>
                          <h3 id="licenceClassesModalTitle">Licence Classes Reference</h3>
                          <p>Australian vehicle licence classes used by the QR driver PIN workflow.</p>
                        </div>
                        <button onClick={this.handleCloseLicenceClasses} type="button" aria-label="Close licence classes reference">
                          <i className="fa fa-times"></i>
                        </button>
                      </div>
                      <div className="asset-licence-reference-body">
                        <div className="asset-licence-reference-table-wrap">
                          <table className="asset-licence-reference-table">
                            <thead>
                              <tr><th>Class</th><th>Vehicle type</th><th>Description</th><th>Trailer limit</th></tr>
                            </thead>
                            <tbody>
                              {LICENCE_CLASSES.map((item) => (
                                <tr key={item.code}>
                                  <td><strong>{item.code}</strong></td><td>{item.vehicle}</td><td>{item.description}</td><td>{item.trailer}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <h4>Licence class hierarchy</h4>
                        <p>Higher heavy vehicle classes authorise the driver to operate lower heavy vehicle classes and standard car-class vehicles.</p>
                        <div className="asset-licence-hierarchy">
                          {LICENCE_CLASSES.map((item) => (
                            <div key={item.code}><strong>{item.code}</strong><span>{item.includes}</span></div>
                          ))}
                        </div>
                        <div className="asset-licence-reference-note">
                          <strong>Important:</strong> Motorcycle licences follow a separate <strong>RE → R</strong> stream. An MC licence does not permit riding motorcycles, and an R licence does not permit driving trucks.
                        </div>
                      </div>
                      <div className="asset-qr-modal-actions">
                        <Button variant="primary" onClick={this.handleCloseLicenceClasses}>Close</Button>
                      </div>
                    </div>
                  </div>
                )}
              </Form>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});

const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditAsset);
